
import ShopAPI from "@/common/api/api_shop";
import type { Order, ORDER_STATUSES } from "@/model/entity/order";
import type { Payment } from "@/model/entity/payment";
import type { PaymentCoupon } from "@/model/entity/payment_coupon";
import { PrintBit } from "@/model/entity/printJobSetting";
import type { ReceiptPaper } from "@/model/entity/receipt_paper";
import {
  createEmptyReceiptPaperDetail,
  ReceiptPaperDetail,
} from "@/model/entity/receipt_paper_detail";
import { Shop } from "@/model/entity/shop";
import type { TableSession } from "@/model/entity/table_session";
import { TranslateServiceBuilder } from "@/services/Translate/translateServiceBuilder";
import store from "@/store/shop";
import _ from "lodash";
import notificationMixin from "../../mixin/notification";

import Vue from "vue";

const translate = TranslateServiceBuilder.Instance()._;
const api = new ShopAPI();

Vue.directive("enhance-defaulot-value", {
  bind: (el) => {
    el.addEventListener("focus", () => {
      const value = el.value;
      if (value === 0) {
        el.value = "";
      }
    });
    el.addEventListener("blur", () => {
      const value = el.value;
      if (value === "") {
        el.value = 0;
      }
    });
  },
});

enum modeType {
  regist = "regist",
  finish = "finish",
}

export default Vue.extend({
  components: {
    QTranslate: () => import("../../components/elements/QTranslate.vue"),
  },
  mixins: [notificationMixin],
  data() {
    return {
      checkedItems: [],
      count: 0,
      couponDiscountPrice: 0,
      discountPrice: 0,
      errors: {},
      isDiscountChecked: false,
      isFinish: false,
      isLoading: false,
      isOpen: false,
      minReceipts: 0,
      mode: null as modeType,
      modeType: modeType,
      newAdditionalDetail: createEmptyReceiptPaperDetail(),
      orders: [] as Order[],
      payment: undefined,
      paymentCoupons: [] as PaymentCoupon[],
      printedReceiptDetails: [] as ReceiptPaperDetail[],
      receiptPaper: undefined as ReceiptPaper,
      receiptPaperOrders: [] as Order[],
      selectedOrders: [] as Order[],
      selectedCoupons: [] as Order[],
      selectedReceiptDetails: [] as ReceiptPaperDetail[],
      selectIssued: [],
      shop: undefined as Shop,
      staffId: store.state.staff.id,
      tableSession: undefined as TableSession,
      taxes: [8, 10],
      totalQuantity: 0,
    };
  },
  mounted() {
    api.set_token(store.state.token);
  },
  computed: {
    price(): number {
      const price = _.sumBy(this.selectedOrders, "price");
      return isNaN(price) ? 0 : price;
    },
    prefix(): string {
      return this.$route.params.prefix || "";
    },
    shoppix(): string {
      return this.$route.params.shoppix || "";
    },
    isReceipt(): boolean {
      const setting = store.state.shopSetting;
      if (!setting) {
        return false;
      }

      return setting.is_receipt;
    },
    isReceiptable(): boolean {
      if (this.isLoading) {
        return false;
      }
      // 発行枚数がない
      if (this.count === 0) {
        return false;
      }
      // 残クーポン額
      const zanCouponPrice = _.sumBy(this.paymentCoupons, "discount_price") - this.couponDiscountPrice;
      // 発行可能額 - 発行額 = 発行可能残額
      let zanReceiptablePrice = this.payment.receiptable_price - this.price;
      // その他割引にチェックが入っている場合はその額を考慮
      if (this.isDiscountChecked) {
        zanReceiptablePrice += this.discountPrice;
      }
      // 発行可能残額が残クーポン額を超えてはいけない
      if (zanReceiptablePrice < zanCouponPrice) {
        this.showErrorNotification("領収書を印刷するには金券を選択してください。");

        return false;
      }

      return this.receiptAmount + this.detailAmount + this.payment.change_price - this.couponDiscountPrice >= 0;
    },
    detailAmount() {
      let amount = 0;
      for (const detail of this.selectedReceiptDetails) {
        console.log(
          "detailAmount2:",
          Number(detail.unit_price),
          Number(detail.quantity),
          detail
        );
        amount += Number(detail.unit_price) * Number(detail.quantity);
      }
      return amount;
    },
    receiptAmount() {
      if (this.price - this.couponDiscountPrice + this.payment.change_price < 0) {
        this.selectIssued = [];
        this.count = 0;
        this.showErrorNotification("割引額が合計金額を超えています。");
      }
      if (this.isDiscountChecked) {
        return this.price - this.discountPrice;
      }
      return this.price;
    },
    detailQuantity() {
      let quantity = 0;
      for (const detail of this.selectedReceiptDetails) {
        quantity += Number(detail.quantity);
      }
      this.totalQuantity = quantity;
      if (quantity > 0) {
        this.selectIssued = [1];
        this.count = 1;
      }
      return quantity;
    },
    isAllSelected() {
      const receiptedOrderCount = this.receiptPaperOrders.length;
      const selectedOrderCount = this.selectedOrders.length;
      const totalOrderCount = Array.from(this.orders).reduce(
        (acc: number, order: Order) => {
          return acc + order.quantity;
        },
        0
      );
      return selectedOrderCount + receiptedOrderCount === totalOrderCount;
    },
    isIndeterminate() {
      const receiptedOrderCount = this.receiptPaperOrders.length;
      const selectedOrderCount = this.selectedOrders.length;
      const totalOrderCount = Array.from(this.orders).reduce(
        (acc: number, order: Order) => {
          return acc + order.quantity;
        },
        0
      );
      return (
        selectedOrderCount > 0 &&
        selectedOrderCount + receiptedOrderCount < totalOrderCount
      );
    },
  },
  watch: {
    mode: {
      handler(newVal) {
        if (newVal) {
          this.isOpen = true;
        }
      },
    },
  },
  methods: {
    // handler
    handlerOpenPopup(
      payment: Payment,
      tableSession: TableSession,
      receiptPaper: ReceiptPaper
    ) {
      this.mode = modeType.regist;
      this.receiptPaper = receiptPaper;
      this.shop = tableSession.shop;
      this.tableSession = tableSession;
      // @FIXME I want use OrderStatus.Paid
      this.orders = payment.orders.filter(order => order.status === 2) || [];
      this.staffId = this.staffId;
      this.payment = payment;
      this.paymentCoupons = payment.payment_coupons;
      this.selectedReceiptDetails = [];
      for (let i = 0; i < tableSession.payments.length; i++) {
        const papers = tableSession.payments[i].receipt_papers;
        for (let j = 0; j < papers.length; j++) {
          const details = papers[j].receipt_paper_details;
          for (let k = 0; k < details.length; k++) {
            this.printedReceiptDetails.push(details[k]);
          }
        }
      }
      this.receiptPaperOrders = [];
      for (let i = 0; i < tableSession.payments.length; i++) {
        const papers = tableSession.payments[i].receipt_papers;
        for (let j = 0; j < papers.length; j++) {
          const details = papers[j].receipt_paper_orders;
          for (let k = 0; k < details.length; k++) {
            this.receiptPaperOrders.push(details[k]);
          }
        }
      }
      this.discountPrice = payment.discount_price || 0;
      this.listChecked = [];
      this.selectIssued = [];
      this.minReceipts = 0;
      this.isDiscountChecked = false;
      this.couponDiscountPrice = 0;
    },
    handleClickAddAdditionalDetail() {
      this.addAdditionalDetail();
    },
    handleClickDelDetail(index): true {
      this.selectedReceiptDetails.splice(index, 1);
      return true;
    },
    handleClickCloseModal: function () {
      this.closeModal();
    },
    handleClickSubmitReceipt: function () {
      if (this.isLoading) {
        return;
      }
      if (this.checkPrice() === false) {
        this.isLoading = false;
        return;
      }
      this.submitReceipt();
    },
    // logic
    addAdditionalDetail() {
      const currentDetail = _.cloneDeep(this.newAdditionalDetail);
      this.selectedReceiptDetails.push(currentDetail);
    },
    filterdReceiptOther(detail, quantity, isDetailSet) {
      const code = this.shop;
      const price = Number(detail.unit_price) * quantity;
      if (code.is_naizei === true) {
        let exclude = price / ((detail.tax_rate + 100) / 100);
        switch (code.tanmatsu) {
          case 2:
            exclude = Math.floor(exclude);
            break;
          case 1:
            exclude = Math.ceil(exclude);
            break;
          default:
            exclude = Math.round(exclude);
            break;
        }
        if (isDetailSet) {
          detail.is_naizei = true;
          detail.tax = price - exclude;
          detail.price = price;
        }
        return this.numberFormat(price);
      }
      let tax = (price * detail.tax_rate) / 100;
      switch (code.tanmatsu) {
        case 1:
          tax = Math.floor(tax);
          break;
        case 2:
          tax = Math.ceil(tax);
          break;
        default:
          tax = Math.round(tax);
          break;
      }
      const total = price + tax;
      if (isDetailSet) {
        detail.is_naizei = false;
        detail.tax = tax;
        detail.price = total;
      }
      return this.numberFormat(total);
    },
    isPrinted(id, index, quantity) {
      return (
        quantity -
          this.receiptPaperOrders.filter(
            (receiptPaperOrder) => receiptPaperOrder.order_id === id
          ).length <=
        index
      );
    },
    isCouponed(id): boolean {
      return this.receiptPaperOrders.some(
        (receiptPaperOrder) => receiptPaperOrder.payment_coupon_id === id
      );
    },
    isDiscounted(discountPrice): boolean {
      return this.receiptPaperOrders.some(
        (receiptPaperOrder) => receiptPaperOrder.discount_price >= discountPrice
      );
    },
    changeListChecked() {
      this.checkedItems = [];
      this.selectedOrders = [];
      const checkedIds = Array.from(
        document.querySelectorAll('input[type="checkbox"].ListCheck:checked')
      ).map((checkbox) => checkbox.id);
      //   console.log(checkedIds);
      for (const checkedId of checkedIds) {
        if (!checkedId) {
          continue;
        }
        const [checkedOrderId, checkedPaymentId, checkedIndex, checkedPrice] =
          checkedId.split("-");
        if (this.checkedItems.includes(checkedId)) {
          this.checkedItems = this.checkedItems.filter(
            (item: string) => item !== checkedId
          );
        } else {
          this.checkedItems.push(checkedId);
          this.selectedOrders.push({
            order_id: checkedOrderId,
            price: Number(checkedPrice),
          });
        }
      }
      this.changeCouponChecked();
      this.getReceiptCount();
      if (this.isDiscountChecked) {
        this.changeDiscountChecked();
      }
    },
    getReceiptCount() {
      if (
        this.checkedItems.length === 0 &&
        this.selectedReceiptDetails.length === 0 &&
        this.couponDiscountPrice === 0
      ) {
        this.minReceipts = 0;
        this.selectIssued = [];
        this.count = 0;
        return;
      }
      // 割引券、金券を適用した場合は、領収書は1枚のみ
      if (this.isDiscountChecked || this.couponDiscountPrice > 0) {
        this.selectIssued = [1];
        this.count = 1;
        return;
      }
      // チェックしたのと完全に同一の領収書が作成できる枚数を算出
      const checkedOrderIds = this.checkedItems.map(
        (item) => item.split("-")[0]
      );
      const orderMap = new Map();
      for (const order of this.orders) {
        let printedCount = this.receiptPaperOrders.filter(
          (item) => item.order_id === order.id
        ).length;
        orderMap.set(order.id, order.quantity - printedCount);
      }
      const countMap = new Map();
      for (const orderId of checkedOrderIds) {
        countMap.set(orderId, (countMap.get(orderId) || 0) + 1);
      }
      let minReceipts = Number.POSITIVE_INFINITY;
      for (const [orderId, neededCount] of countMap) {
        if (!orderMap.has(orderId)) {
          minReceipts = 0;
          break;
        }
        const availableCount = orderMap.get(orderId);
        minReceipts = Math.min(
          minReceipts,
          Math.floor(availableCount / neededCount)
        );
      }
      // minReceipts = Math.min(minReceipts, this.calcMaxReceiptsByCoupon());
      this.minReceipts = minReceipts;
      if (this.detailQuantity > 0) {
        minReceipts = 1;
      }
      this.selectIssued = Array.from({ length: minReceipts }, (_, i) => i + 1);
      // 未選択なら 1 枚を選択する
      this.count = this.count ? this.count : 1;
      // 選択可能数を超えた枚数が選択されていたら、選択可能数まで下げる
      this.count = (this.count <= minReceipts) ? this.count : minReceipts;
    },
    changeCouponChecked() {
      this.couponDiscountPrice = 0;
      let couponDiscountPrice = 0;
      // class="CouponCheck"のチェックボックスのidを取得
      const couponIds = Array.from(
        document.querySelectorAll('input[type="checkbox"].CouponCheck:checked')
      ).map((checkbox) => checkbox.id);
      // チェックが入っているidのクーポンの割引額を取得
      for (const couponId of couponIds) {
        if (!couponId) {
          continue;
        }
        const choicedCoupon = this.paymentCoupons.find(
          (coupon) => coupon.id === couponId
        );
        couponDiscountPrice += choicedCoupon.discount_price;
        this.selectedCoupons.push({
          payment_coupon_id: couponId,
          discount_price: choicedCoupon.discount_price * -1,
        });
      }
      if (this.price < 0) {
        this.showErrorNotification("金券の金額が合計金額を超えています。");
      } else {
        this.couponDiscountPrice = couponDiscountPrice;
      }
    },
    errorForm(path: string): Array<Array<string>> {
      return (
        path.split(".").reduce((acc, key) => {
          return acc ? acc[key] : undefined;
        }, this.errors) || []
      );
    },
    numberFormat(number) {
      if (typeof number !== "number" || isNaN(number)) {
        return 0;
      }
      return number.toLocaleString();
    },
    changeDiscountChecked() {
      if (this.isDiscountChecked) {
        const newAmount = this.price + this.detailAmount + this.payment.change_price - this.discountPrice;
        if (newAmount < 0) {
          this.$nextTick(() => {
            this.isDiscountChecked = false;
          });
          this.selectIssued = [];
          this.count = 0;
          this.showErrorNotification("割引額が合計金額を超えています。");
        } else {
          // 割引券を適用した場合は、領収書は1枚のみ
          this.selectIssued = [1];
          this.count = 1;
        }
      }
    },
    closeModal() {
      this.isLoading = false;
      this.mode = undefined;
      this.isOpen = false;
      this.order = {};
      this.count = 0;
      this.$emit("close");
    },
    statusAttr(): string {
      return this.isFinish ? "success" : "info";
    },
    checkPrice: function () {
      const rtn = _.sumBy(this.selectedReceiptDetails, "price");
      const selectedPrice = this.payment.receiptable_price + rtn;

      let price = this.price;
      if (this.isDiscountChecked) {
        price -= this.discountPrice;
      }
      if ((price + this.detailAmount) * this.count > selectedPrice) {
        if ((price + this.detailAmount) * this.count - selectedPrice === this.discountPrice && this.discountPrice > 0 && !this.isDiscountChecked) {
          this.showErrorNotification(translate("hall-0290", "その他割引・クーポン を未適用のままでは領収書が発行できません"));
        } else {
          this.showErrorNotification(translate("hall-0285", "発行枚数 が正しくありません"));
        }
        return false;
      }
      if (this.count === 0) {
        return false;
      }
      return true;
    },

    // api
    submitReceipt() {
      let message = "";
      let price = this.price + this.detailAmount;
      let discount = [];
      if (this.isDiscountChecked) {
        price -= this.discountPrice;
        discount.push({
          discount_price: this.discountPrice,
        });
      }
      const receipt = {
        table_session_id: this.tableSession.id,
        staff_id: this.staffId,
        payment_id: this.payment.id,
        // payment: {},
        print_job_id: null,
        price,
        receipt_paper_details: this.selectedReceiptDetails,
        receipt_paper_orders: [...this.selectedOrders, ...this.selectedCoupons, ...discount],
      } as ReceiptPaper;

      api
        .receipt_receipt({
          receipt_paper: receipt,
          count: this.count,
          print_rule_id:
            store.state.printRule[PrintBit.TYPE_SETTLE_AND_RECEIPT],
        })
        .then(() => {
          this.mode = modeType.finish;
          this.$emit("registered");
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.errors.payment = message;
          this.errors.receipt_paper = err.response.data.errors.receipt_paper;
          this.isLoading = false;
        });
    },
    toggleAll() {
      const receiptedOrderCount = this.receiptPaperOrders.length;
      const selectedOrderCount = this.selectedOrders.length;
      const totalOrderCount = Array.from(this.orders).reduce(
        (acc: number, order: Order) => {
          return acc + order.quantity;
        },
        0
      );
      if (selectedOrderCount === 0) {
        console.log("none");
        this.checkAllListItems();
      } else if (selectedOrderCount + receiptedOrderCount < totalOrderCount) {
        console.log("part");
        this.checkAllListItems();
      } else {
        console.log("all");
        this.uncheckAllListItems();
      }
      this.changeListChecked();
    },
    checkAllListItems() {
      const checkboxes = Array.from(
        document.querySelectorAll<HTMLInputElement>(
          'input[type="checkbox"].ListCheck'
        )
      );

      checkboxes.forEach((checkbox) => {
        if (!checkbox.disabled) {
          checkbox.checked = true;
        }
      });
    },
    uncheckAllListItems() {
      const checkboxes = Array.from(
        document.querySelectorAll<HTMLInputElement>(
          'input[type="checkbox"].ListCheck'
        )
      );

      checkboxes.forEach((checkbox) => {
        if (!checkbox.disabled) {
          checkbox.checked = false;
        }
      });
    },
  },
});
